<template>
  <top />
  <div id="page">
    <router-view />
  </div>
  <bottom />
</template>

<script>
import top from "@/components/Top";
import bottom from "@/components/Bottom";

export default {
  name: "App",
  head: {
    meta: [{ name: "charset", content: "utf-8" }],
  },
  components: {
    top,
    bottom,
  },
  mounted() {
    window.onscroll = function () {
      let header = document.getElementsByTagName("header")[0];
      let sections = document.getElementsByTagName("section");
      let floating_button = document.getElementsByClassName("down-button")[0];

      let section_offsets = sections[1].getBoundingClientRect();
      if (section_offsets.top <= 200) {
        header.style.backgroundColor = "#4e4d4d";
        header.querySelector("img").style.maxHeight = "30px";
      } else {
        header.style.backgroundColor = "unset";
        header.querySelector("img").style.maxHeight = "50px";
      }

      if (floating_button) {
        section_offsets = sections[0].getBoundingClientRect();
        if (section_offsets.top < 0) {
          floating_button.style.display = "none";
        } else {
          floating_button.style.display = "unset";
        }
      }
    };
  },
};
</script>

<style lang="less">
@import url("@mdi/font/css/materialdesignicons.css");
@import url("./assets/style/default.less");
</style>
